import { Component, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ApiserviceService } from "../../../../../../src/app/apiservice.service";
import { NotificationService } from "../../../../../../src/app/admin/services/notification.service";

@Component({
  selector: "app-add-edit-master",
  templateUrl: "./add-edit-master.component.html",
  styleUrls: ["./add-edit-master.component.scss"],
})
export class AddEditMasterComponent {
  isLoading: boolean = false;
  button_label: string = "Submit";
  dialogTitle: string = "Create Master";
  dialogSubTitle: string = "Fill in the details below to add a new master record";
  createMasterForm!: FormGroup;
  selected_lang = 1;
  language_list = [
    { value: 1, viewValue: "English" },
    { value: 2, viewValue: "Arabic" }
  ];
  masterDataList: any;
  optionMasterData: any;
  isEdit: boolean = false;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddEditMasterComponent>,
     private notify: NotificationService, // Injecting notification service for user notification
    private api: ApiserviceService,
     @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
      if (this.data) {
      this.masterDataList = this.data.MasterData;
            // Suppose this.api.language holds the current language ID
      const currentLangId = this.api.language;

      // Convert masters into dropdown options
      this.optionMasterData = this.masterDataList.map((master: any) => ({
        value: master.id,
        viewValue: master.label?.[currentLangId] || master.name || 'Unnamed'
      }));

      console.log('Dropdown Options:', this.optionMasterData);
    }
    console.log('selected MAster data', this.data);
  }


  ngOnInit(): void {
    this.createMasterForm = this.fb.group({
      masterName: ["", [Validators.required, Validators.maxLength(64),
      Validators.pattern(/^[A-Za-z0-9_]*$/)]],
      masterLabels: this.fb.array([]),
      // parentMaster: [""],
    });
     // If edit, patch data
  if (this.data?.type === 'edit' && this.data?.selectedValue) {
    this.isEdit = true;
    this.button_label = "Update";
    this.dialogTitle = "Update Master";
    this.dialogSubTitle = "Update the details of the master record";
    const selected = this.data.selectedValue;

    // 1️⃣ Patch simple fields
    this.createMasterForm.patchValue({
      masterName: selected.name,
      // parentMaster: selected.master_id,
    });

    // 2️⃣ Patch FormArray for labels
    const labelsArray = this.createMasterForm.get('masterLabels') as FormArray;
    labelsArray.clear(); // clear default empty row

    if (selected.label && typeof selected.label === 'object') {
      Object.entries(selected.label).forEach(([langId, labelValue]) => {
        labelsArray.push(this.fb.group({
          language: Number(langId),
          label: labelValue as string,
        }));
      });
    }
  } else {
    // If add, just add one row for first language
    this.addLabelRow();
  }
  }

  // Create a single label group (language + label)
  createLabelGroup(): FormGroup {
    return this.fb.group({
      language: ["", Validators.required],
      label: ["", [Validators.required, Validators.maxLength(64)]],
    });
  }

  // Get form array
  get masterLabels(): FormArray {
    return this.createMasterForm.get("masterLabels") as FormArray;
  }

  // Add new label row
  addLabelRow(): void {
    this.masterLabels.push(this.createLabelGroup());
  }

  // Remove specific row
  removeLabelRow(index: number): void {
    if (this.masterLabels.length > 1) {
      this.masterLabels.removeAt(index);
    }
  }

    onSubmit(): void {
     if (this.createMasterForm.invalid) {
      this.createMasterForm.markAllAsTouched();
      return;
    }
    // English mandatory check
const labels = this.masterLabels.value;
const hasEnglish = labels.some(l => Number(l.language) === 1);
const hasNonEnglish = labels.some(l => Number(l.language) !== 1);
// Duplicate language check
const languages = labels.map(l => Number(l.language));
const duplicates = languages.filter((item, index) => languages.indexOf(item) !== index);

if (hasNonEnglish && !hasEnglish) {
  this.notify.notify("English label is required when using other languages.", "warn");
  return;
}

if (duplicates.length > 0) {
  this.notify.notify("Same language cannot be added multiple times.", "warn");
  return;
}
  if (this.data?.type === 'edit') {
    this.updateMasterValue();
  } else {
    this.createNewMasterValue();
  }
}

  // Submit form
  createNewMasterValue(): void {
    const url = "masters";
    const formValue = this.createMasterForm.value;
    const payload = {
      master_name: formValue.masterName,
      master_label: formValue.masterLabels.reduce((acc, item) => {
        acc[item.language] = item.label;
        return acc;
      }, {} as { [key: number]: string }),
      status: 1,
      added_by: this.api.user_id,
    };
    console.log(payload, "payload");
this.isLoading = true
    this.api.postGmsData(url, payload).subscribe({
      next: (res) => {
        this.isLoading = false
        console.log('Master created successfully', res);
        this.createMasterForm.reset();
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false
        console.error('Error creating master', err);
      }
    });
  }


  updateMasterValue(): void {
    const url = "masters";
    const formValue = this.createMasterForm.value;
    const payload = {
      master_name: formValue.masterName,
      master_id: this.data?.selectedValue?.id,
      master_label: formValue.masterLabels.reduce((acc, item) => {
        acc[item.language] = item.label;
        return acc;
      }, {} as { [key: number]: string }),
      status: 1,
      added_by: this.api.user_id,
    };
    console.log(payload, "payload");
   this.isLoading = true
    this.api.patchGmsData(url, payload).subscribe({
      next: (res) => {
        this.isLoading = false
        console.log('Master created successfully', res);
        this.createMasterForm.reset();
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false
        console.error('Error creating master', err);
      }
    });
  }

  // Cancel / Reset
  onCancel(): void {
    this.dialogRef.close(); // ✅ closes the popup
  }

  // Helper to check errors easily in template
  hasError(control: any, errorType: string): boolean {
    return control.hasError(errorType) && (control.dirty || control.touched);
  }
}
